import { render } from "./AdminProduct.vue?vue&type=template&id=24ee76d5&scoped=true"
import script from "./AdminProduct.vue?vue&type=script&lang=js"
export * from "./AdminProduct.vue?vue&type=script&lang=js"

import "./AdminProduct.vue?vue&type=style&index=0&id=24ee76d5&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24ee76d5"]])

export default __exports__